export default __webpack_public_path__ + "static/media/frank_gaillard.af1486d1.jpg";